import React from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components';
import objectPath from 'object-path';
import screen from 'superior-mq';
import { bp } from 'Styles/helpers';
import Section from '../../section';
import Container from '../../container';
import PurposeCarousel from '../../purpose-carousel';
import Button from '../../button';
import RenderMd from '../../render-md';

const CaseStudyContent = props => (
  <Section styles="padding-bottom: 0 !important;">
    <Container>

      <div style={{ textAlign: 'center' }}>

        {props.title &&
          <h2>{props.title}</h2>
        }

        {props.impactDescription &&
          <ReportDescription>
            <RenderMd source={props.impactDescription} />
          </ReportDescription>
        }

        {objectPath.has(props, 'impactReport.fields.file.url') &&
          <Button href={props.impactReport.fields.file.url}>
            Download Report
          </Button>
        }
      </div>

    </Container>

    <PurposeCarousel slides={props.carouselSlides} />
  </Section>
);

const ReportDescription = styled.div`
  margin: 50px auto 60px;
  max-width: 580px;

  ${screen.below(bp.mobile, `
    margin: 40px auto 60px;
  `)}
`;

CaseStudyContent.propTypes = {
  impactReport: PropTypes.object,
  title: PropTypes.string,
  impactDescription: PropTypes.string,
  carouselSlides: PropTypes.array,
};

export default CaseStudyContent;
